// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__zsJ41","page-title":"HomePage_page-title__1zrm3"};